import request from '@/_helpers/requests/requestNotif'

export const textsService = {
    information() {
        return new Promise((resolve) => {

            request.get('information').then(response => {
                resolve(response.data)
            });
        });
    },
    polity(option) {
        return new Promise((resolve) => {

            request.get('polity/' + option).then(response => {
                
                resolve(response.data['text'])
            });
        });
    },
    idiomas() {
        return new Promise((resolve) => {
            request.get('idiomas').then((response) => {
                resolve(response.data);
            });
        });
    }
};